// RsvpTracker.tsx
import React from "react";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import CustomPagination from "../../components/CustomPagination";
import FilterMenu from "../../components/filterMenu";
import RsvpTable from "./rsvpTable";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function RsvpTracker() {
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const navigate = useNavigate();

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const tabCategories = ["All", "Dining", "Event", "Experience"];
  const statusTabs = ["New", "In Progress", "Confirmed", "Completed"];

  const currentCategory = tabCategories[valueTabs];
  const currentStatus = statusTabs[valueTabs1];

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Booking & RSVP Tracker</h1>
        </div>
        <div className="right_s">
          <SearchBar searchTerm={""} placeholder={"Search offer"} />
          <Button className="btn btn_primary"   onClick={() =>
                        navigate("/manage-booking-resvp/add-user-booking")
                      } >Add User</Button>
          <FilterMenu />
        </div>
      </div>

      <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          className="custom_tabs_links"
        >
          <Tab label="All" {...a11yProps(0)} />
          <Tab label="Dining" {...a11yProps(1)} />
          <Tab label="Events" {...a11yProps(2)} />
          <Tab label="Experience" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <Box className="custom_tabs1 mb_30" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs1}
          onChange={handleChangeTabs1}
          className="custom_tabs_links"
        >
          <Tab label="New Bookings" {...a11yProps(0)} />
          <Tab label="In progress" {...a11yProps(1)} />
          <Tab label="Confirmed" {...a11yProps(2)} />
          <Tab label="Completed" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTabs1} index={valueTabs1}>
        <RsvpTable category={currentCategory} statusFilter={currentStatus} />
      </CustomTabPanel>

      <CustomPagination />
    </MainContainer>
  );
}

export default RsvpTracker;
